<ng-container *ngIf="!(isPartOfArNavigation$ | async)">
    <div class="alert alert-danger">
        {{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}
    </div>
</ng-container>
<ng-container *ngIf="isPartOfArNavigation$ | async" content [ngSwitch]="dataState">
    <div *ngSwitchCase="DataState.Loading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <ng-container *ngSwitchCase="DataState.Success">
        <ham-button *ngIf="debuggingFeaturesEnabled" variant="primary" (click)="onDeleteSwitchAccountClicked()">
            WIPE Switch Account Properties to simulate old switch account behavior</ham-button
        >
        <app-update-banner
            *ngIf="showSwitchToAutomaticTransferOfAnnualResultBanner"
            style="margin-bottom: 16px"
            messageLocalizationKey="aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description"
            buttonLocalizationKey="aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirm"
            [dismissible]="true"
            (dismiss)="
                showSwitchToAutomaticTransferOfAnnualResultBanner = false;
                onAutomaticTransferOfAnnualResultEnabledChange(false)
            "
            (confirm)="showSwitchToAutomaticTransferConfirmationModal = true"
        >
        </app-update-banner>
        <templates-account-mapping-form
            *ngIf="
                activeAnnualReport != null &&
                isMappingInputReady &&
                rawIncomeTemplate != null &&
                rawBalanceTemplate != null
            "
            [isSavedMode]="isSavedMode"
            [enforceOverwrite]="enforceOverwrite"
            [accountMappingInput]="accountMappingInput"
            [businessModel]="businessModel"
            [currency]="currency"
            [reportLocale]="activeAnnualReport.locale"
            [language]="currentLanguage"
            [languages]="supportedLocales"
            [isPreviousDataTakenFromPreviousBalanceAnnualReport]="
                isPreviousYearDataTakenFromPreviousBalanceAnnualReport
            "
            [isPreviousDataTakenFromPreviousIncomeAnnualReport]="isPreviousYearDataTakenFromPreviousIncomeAnnualReport"
            [previousAnnualProfit]="previousAnnualProfitForMissingIncomePeriod"
            [shouldUsePreviousAnnualProfitFromCurrentIncomeStatement]="
                shouldUsePreviousAnnualProfitFromCurrentIncomeStatement
            "
            [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
            [applyAutomaticTransferOfAnnualResultForCurrentAndPreviousValues]="
                applyAutomaticTransferOfAnnualResultForCurrentAndPreviousValues
            "
            [supportOperation]="supportOperation"
            [profitOfTheYearFliName]="profitOfTheYearFliName"
            [annualSurplusFliName]="annualSurplusFliName"
            [uncoveredShortfallAssetsFliName]="uncoveredShortfallAssetsFliName"
            [uncoveredShortfallLiabilitiesFliName]="uncoveredShortfallLiabilitiesFliName"
            [cashAndCashFli]="cashAndCashFli"
            [templatesTranslations$]="templatesTranslations$"
            [previousYearClosingIncomeFromAutofillReport]="previousYearClosingIncomeFromAutofillReport"
            [hasPreviousData]="!activeAnnualReport.generalInformation.noPreviousData"
            [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
            [allFinancialLineItems]="allFinancialLineItems"
            (balanceChangedEventEmitter)="balanceChanged($event)"
            (incomeChangedEventEmitter)="incomeChanged($event)"
            (addOrUpdateAccountInActiveReport)="onAccountChangedInReport($event)"
            (fliOrGroupDeleted)="onFliOrGroupDeleted($event)"
            (translateTemplate)="onTranslateTemplate()"
            (specialFliChange)="specialFliChanged($event)"
            (errorInProfitFliDetected)="onErrorInProfitFliDetected($event)"
            (automaticTransferOfAnnualResultEnabledChange)="onAutomaticTransferOfAnnualResultEnabledChange($event)"
            [previousYearBalanceTemplate]="previousYearBalanceTemplate"
            [previousYearIncomeTemplate]="previousYearIncomeTemplate"
            [previousYearImportedTaxonomy]="previousYearImportedTaxonomy"
            [copiedFinStatements]="copiedFinStatements"
        >
        </templates-account-mapping-form>
    </ng-container>

    <div *ngSwitchCase="DataState.Error">
        <div *ngIf="templateNotFoundError" class="alert alert-danger">
            {{ localizationKeys.aumico_reports_template_not_found | i18next }}
        </div>
        <div *ngIf="dataIncompleteError" class="alert alert-danger">
            {{ localizationKeys.aumico_reports_required_data_not_completed | i18next }}
        </div>
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
        nextButtonText="{{ nextStepLabel | i18next }}"
        [nextButtonAction]="proceedButtonClicked"
        nextButtonRouterLink="../../{{ nextStepPath }}"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{ previousStepPrefix | i18next }}"
        backButtonText="{{ uploadStepLabel | i18next }}"
        backButtonRouterLink="../{{ uploadStepPath }}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
<ham-confirm-decline-modal
    *ngIf="debuggingFeaturesEnabled && openWipeSwitchAccountDialog"
    (cancel)="openWipeSwitchAccountDialog = false"
    (action)="onWipeSwitchAccountConfirm()"
    footerAlignment="center"
    actionBtnText="Okay"
    noActionBtnText="Cancel"
    btnVariant="primary"
>
    <p>Are you sure you want to wipe all switch account properties?</p>
    <p>
        After it will saved the report, you need to navigate to the projects overview page without further saving.
        Otherwise you might alter it again.
    </p>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showSwitchToAutomaticTransferConfirmationModal"
    (cancel)="showSwitchToAutomaticTransferConfirmationModal = false"
    (action)="
        showSwitchToAutomaticTransferConfirmationModal = false; onAutomaticTransferOfAnnualResultEnabledChange(true)
    "
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_project_reports_switch_to_automatic_transfer_of_annual_result_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="
            'aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirmation_description' | i18next
        "
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
